export default __webpack_public_path__ + "static/media/social-github-icon.660dfeeb.svg";